/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cool_Fair_Buck_CookInputs */

const en_cool_fair_buck_cook = /** @type {(inputs: Cool_Fair_Buck_CookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage the user's language settings`)
};

const de_cool_fair_buck_cook = /** @type {(inputs: Cool_Fair_Buck_CookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwalten Sie die Spracheinstellungen des Benutzers`)
};

/**
* | output |
* | --- |
* | "Manage the user's language settings" |
*
* @param {Cool_Fair_Buck_CookInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cool_fair_buck_cook = /** @type {((inputs?: Cool_Fair_Buck_CookInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cool_Fair_Buck_CookInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cool_fair_buck_cook(inputs)
	return de_cool_fair_buck_cook(inputs)
});